import React from 'react';
import { DefinitionListItem } from '@cp-shared-15/frontend-ui';
import {
    ContractDataWithLinks,
    EarlySettlementData,
    FinancialDetails,
    formatAsCurrency,
    formatAsDate,
} from 'cpie-common';
import { TFunction } from 'i18next';
import { LicensePlate } from '../license-plate';

export const getEarlySettlementContractDetailsListItems = (
    t: TFunction,
    contract: ContractDataWithLinks,
    financialDetails: FinancialDetails,
): DefinitionListItem[] => {
    const items: DefinitionListItem[] = [
        {
            label: t('overview.start-date'),
            value: formatAsDate(financialDetails.startDate),
        },
        {
            label: t('overview.end-date'),
            value: formatAsDate(financialDetails.endDate),
        },
        {
            label: t('overview.total-deposit'),
            value: formatAsCurrency(financialDetails.totalDeposit),
        },
        {
            label: t('overview.financed-amount'),
            value: formatAsCurrency(financialDetails.financedAmount),
        },
        {
            label: t('overview.term'),
            value: financialDetails.term,
        },
        {
            label: t('overview.guaranteed-mimimum-future-value'),
            value: formatAsCurrency(financialDetails.guaranteedMinimumFutureValue),
        },
        {
            label: t('overview.license-plate'),
            value: <LicensePlate registrationNumber={contract.licensePlate} />,
        },
        {
            label: t('overview.final-payment-date'),
            value: formatAsDate(financialDetails.finalPaymentDate),
        },
    ];

    return items;
};

export const getEarlySettlementEnquiryDetailsListItems = (
    t: TFunction,
    earlySettlementData: EarlySettlementData,
): DefinitionListItem[] => {
    const items: DefinitionListItem[] = [
        {
            label: t('enquiry.start-date'),
            value: formatAsDate(new Date().toISOString()),
        },
        {
            label: t('enquiry.valid-until-date'),
            value: formatAsDate(earlySettlementData.enquiryValidUntil as string),
        },
    ];

    return items;
};

export const getEarlySettlementFinancialDetailsListItems = (
    t: TFunction,
    earlySettlementData: EarlySettlementData,
): DefinitionListItem[] => {
    const items: DefinitionListItem[] = [
        {
            label: t('financial-overview.outstanding-balance'),
            value: formatAsCurrency(earlySettlementData.outstandingBalance),
        },
        {
            label: t('financial-overview.interest-not-charged'),
            value: formatAsCurrency(earlySettlementData.interestSaving),
            tooltip: t('financial-overview.interest-not-charged-disclaimer'),
        },
        {
            label: t('financial-overview.arrears'),
            value: formatAsCurrency(earlySettlementData.arrears),
        },
    ];

    return items;
};

export const getEarlySettlementTotalList = (t: TFunction, earlySettlementData: EarlySettlementData) => {
    const items: DefinitionListItem[] = [
        {
            label: <b className="u-font-size-fs3">{t('total-settlement-amount')}</b>,
            value: (
                <span className="u-font-size-fs3">{formatAsCurrency(earlySettlementData.totalSettlementAmount)}</span>
            ),
        },
    ];

    return items;
};
